import { render } from "./ServiceModal.vue?vue&type=template&id=55812785&scoped=true"
import script from "./ServiceModal.vue?vue&type=script&lang=js"
export * from "./ServiceModal.vue?vue&type=script&lang=js"

import "./ServiceModal.vue?vue&type=style&index=0&id=55812785&lang=scss&scoped=true"

import exportComponent from "/Users/marc.bush/Sites/ensotyres/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55812785"]])

export default __exports__